import { FormControl, FormHelperText } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { ConcentrationCalcFieldLabel } from './ConcentrationCalcFieldLabel';
import { makeSelectOptions } from './makeSelectOptions';
import { Select } from 'packages/common-frontend/components/Select';

export const SourceConfigTypeEditor = ({
  value,
  onChange,
}: {
  value: CreditAgreement.Config.ConcentrationLimit.Calculation.SourceConfigType;
  onChange: (
    newValue: CreditAgreement.Config.ConcentrationLimit.Calculation.SourceConfigType,
  ) => void;
}) => {
  const selectOptions = makeSelectOptions(
    CreditAgreement.Config.ConcentrationLimit.Calculation.SourceConfigIterable,
  );
  const calculationTypeExamples: {
    [key in CreditAgreement.Config.ConcentrationLimit.Calculation.SourceConfigType]: string;
  } = {
    standard:
      'Example: The top obligor cannot exceed 10% of the total exposure',
    weightedAverage:
      'Example: The weighted average internal rate of return must be at least 20%',
    exposureByGroup:
      'Example: no single industry can have more than 10% of the total exposure',
    directInsert: 'Example: The kickout is specified by field on the loan-tape',
    pointer:
      'This is to select a custom method that does not fit the above types',
  };

  return (
    <FormControl mb={4}>
      <ConcentrationCalcFieldLabel
        m={1}
        label="Calculation Type"
        tooltip="Select the concentration limit calculation methodology."
      />

      <Select<CreditAgreement.Config.ConcentrationLimit.Calculation.SourceConfigType>
        value={value}
        onChange={(val) => {
          if (val) {
            onChange(val);
          }
        }}
        options={selectOptions}
      />
      <FormHelperText>{calculationTypeExamples[value]}</FormHelperText>
    </FormControl>
  );
};
